<form [formGroup]="filterFormGroup()">
  <div class="table-responsive">
    <div class="datatable mt-4">
      <div class="datatable-inner border-bottom" mdbScrollbar style="position: relative;">
        <table
          class="table table-striped table-bordered datatable-table"
          mdbTable
          mdbTableSort
          #table="mdbTable"
          #sort="mdbTableSort"
          [dataSource]="data()"
          [fixedHeader]="true"
          (sortChange)="sortColumn($event)"
          [sort]="sort">
          <thead class="datatable-header">
            @if (Object.keys(filterFormGroup().controls).length > 0) {
              <tr>
                @if (selectable()) {
                  <th></th>
                }
                @for (column of columns(); track column) {
                  <th class="filter-form-controls">
                    @if (column.filterFormControl) {
                      <app-filter-form-control [column]="column"
                                               [filterFormGroup]="filterFormGroup()"></app-filter-form-control>
                    }
                  </th>
                }
              </tr>
            }

            <tr class="table-head-row">
              @if (selectable()) {
                <th>
                  @if (allowMultiSelect()) {
                    <div class="form-check">
                      <input
                        mdbCheckbox
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        [checked]="isAllSelected()" (checkboxChange)="$event.checked ? selectAll() : unselectAll()"/>
                    </div>
                  }
                </th>
              }

              @for (header of columns(); track header) {
                <th [mdbTableSortHeader]="header.name ?? ''" scope="col" [disableSort]="(header.name ?? '') == ''">
                  {{ header.name ?? '' | translate  }}
                </th>
              }
            </tr>

          </thead>

          @if (!hideTableBody) {
            <tbody class="datatable-body">
              @for (data of table.data; track data) {
                <tr scope="row">
                  @if (selectable()) {
                    <td>
                      <div class="form-check">
                        <input
                          mdbCheckbox
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          [checked]="isSelected(data)" (checkboxChange)="$event.checked ? select(data) : unselect(data)"/>
                      </div>
                    </td>
                  }
                  @for (column of columns(); track column) {
                    <td class="position-relative">
                      @if (column.selector || column.customValueFunction) {
                        <!-- TEXT -->
                        @if (!column.isCheckbox &&
                          !column.isImage &&
                          !column.isDate &&
                          !column.enum &&
                          !column.isRating &&
                          !column.isPrice &&
                          !column.isColor &&
                          !column.arraySelector &&
                          !column.customValueFunction &&
                          !column.link) {
                          @if (getData(column.selector, data) != 'null') {
                            <span>
                              <span>{{ getData(column.selector, data,false, column.optionalSelector) }}</span>
                              @if (column.suffix) {
                                <span>&nbsp;{{ column.suffix | translate }}</span>
                              }
                            </span>
                          }
                          @if (getData(column.selector, data) == 'null') {
                            <span>-</span>
                          }
                        }
                        @if(column.customValueFunction) {
                          @let value = column.customValueFunction(data);
                          @if(!value) {
                            <span>-</span>
                          } @else {
                            @if (value.booleanValue != null) {
                              <div class="form-check">
                                <input
                                  mdbCheckbox
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  [checked]="value.booleanValue"
                                  [disabled]="true"/>
                              </div>
                            } @else if(!value.link) {
                              <span>{{ value.text ? (value.text | translate) : "-" }}</span>
                            } @else {
                              <a target="_blank" href="{{ value.link }}" class="d-flex align-items-center gap-1">
                                <span>{{ value.text | translate }}</span>
                                <i class="fas fa-external-link ms-1"></i>
                              </a>
                            }
                          }
                        }
                        <!-- LINK -->
                        @if (column.link) {
                          @if (getData(column.selector, data) == "null") {
                            <span>-</span>
                          } @else {
                            <a target="_blank" href="{{ getLink(column.link, data) }}" class="d-flex align-items-center gap-1">
                              <span>{{ getData(column.selector, data) }} @if (column.suffix) {
                                <span
                                >{{ column.suffix | translate }}</span>
                              }</span>
                              <i class="fas fa-external-link ms-1"></i>
                            </a>
                          }
                        }
                        <!-- ARRAY -->
                        @if (column.arraySelector) {
                          <div [class.d-flex]="column.showArrayEntriesInline">
                            @for (entry of getArrayData(column.arraySelector!, data); track entry; let i = $index) {
                              <div>
                                @if (column.showArrayEntriesInline && i > 0) {
                                  <span>,&nbsp;</span>
                                }
                                <span>{{ getData(column.selector, entry) }} </span>
                              </div>
                            }
                          </div>
                        }
                        <!-- DATE -->
                        @if (column.isDate) {
                          {{ (getData(column.selector, data) != 'null' && getData(column.selector, data) != '-') ? (getData(column.selector, data) | date: environment.displayDateFormat) : '-' }}
                        }
                        <!-- PRICE -->
                        @if (column.isPrice) {
                          {{ getData(column.selector, data) != 'null' ? (getData(column.selector, data) | currency: 'EUR') : '-' }}
                        }
                        <!-- ENUM -->
                        @if (column.enum) {
                          {{ column.enumCastFunction(getData(column.selector, data)) | translate }}
                        }
                        <!-- RATING -->
                        @if (column.isRating) {
                          <div class="d-flex gap-3 align-items-center">
                            <span>{{ getData(column.selector, data) != "null" ? (+getData(column.selector, data) | number : "1.1-1") : "-" }}</span>
                            <app-star-rating [max]="5" [rating]="+getData(column.selector, data)"></app-star-rating>
                          </div>
                        }
                        <!-- CHECKBOX -->
                        @if (column.isCheckbox && !column.customValueFunction) {
                          <div class="form-check">
                            <input
                              mdbCheckbox
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              [checked]="getData(column.selector, data) == 'true'"
                              [disabled]="true"/>
                          </div>
                        }
                        <!-- IMAGE -->
                        @if (column.isImage) {
                          <img ngSrc="{{ getData(column.selector, data) }}" [fill]="true"/>
                        }
                        @if (column.isColor) {
                          <input type="color"
                            disabled
                            class="form-control form-control-color p-0"
                            [mdbTooltip]="getData(column.selector, data)"
                            [value]="getData(column.selector, data)">
                        }
                      }
                      <!-- BUTTONS -->
                      @if (column.buttons) {
                        <div class="d-flex gap-2">
                          @for (button of column.buttons; track button) {
                            @if(button.isObjectLink || button.routerLink || button.customLink) {
                              @let link = getButtonLink(button, data);
                              <a [routerLink]="link" [target]="button.linkTarget ?? '_self'">
                                <app-mdb-button [color]="button.color ?? 'primary'" [text]="button.text"
                                  [iconClass]="button.iconClass" [iconPosRight]="button.iconPosRight"
                                  [outlined]="button.outlined" [floating]="button.floating"
                                  [loading]="button.loading" [size]="button.size"
                                customClasses="{{button.customClasses}}"></app-mdb-button>
                              </a>
                            } @else {
                              <app-mdb-button [color]="button.color ?? 'primary'" [text]="button.text"
                                [iconClass]="button.iconClass" [iconPosRight]="button.iconPosRight"
                                [outlined]="button.outlined" [floating]="button.floating"
                                [loading]="btnLoading(button, +getData(null, data, true))" [size]="button.size"
                                customClasses="{{button.customClasses}}"
                                (onClick)="(button.onClick) ? button.onClick(getData(null, data, true)) : null"
                              [routerLink]="button.routerLink"></app-mdb-button>
                            }
                          }
                        </div>
                      }
                    </td>
                  }
                </tr>
              }
            </tbody>
          }
        </table>

        @if (loading().loading) {
          <div class="datatable-loader bg-light">
            <span class="datatable-loader-inner">
              <span class="datatable-progress bg-primary"></span>
            </span>
          </div>
          <p class="text-center text-muted my-4">{{ 'LOADING_RESULTS' | translate }}</p>
        }

      </div>

      <div class="d-flex justify-content-end">
        @if (pagination() != null) {
          <app-pagination [paginationMeta]="pagination()!" (nextClicked)="paginationNext()"
          (previousClicked)="paginationPrevious()" [loading]="loading().loading"></app-pagination>
        }
      </div>
    </div>
  </div>
</form>
